import { client } from '..';
import { NotificationFeedResponse } from '../models/notificationsModels';

export const registerDeviceFCMToken = async ({ token }: { token: string }): Promise<any> => {
  const url = '/notifications/register-token';

  const { data } = await client.post(url, {
    token: token
  });

  return data;
};

export const getNotificationFeed = async ({
  queryKey,
  pageParam
}: {
  queryKey: (string | number | boolean | undefined)[];
  pageParam: string | undefined;
}): Promise<NotificationFeedResponse> => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, __, limit, markAsRead] = queryKey;

  const url = `/notifications/feed?limit=${limit}${pageParam !== undefined ? `&n=${pageParam}` : ''}${markAsRead !== undefined ? `&markAsRead=${markAsRead}` : ''}`;

  const response = await client.get(url);

  return response.data;
};

export const markAsRead = async ({ n, limit }: { n: number; limit: number }): Promise<any> => {
  const { data } = await client.patch(`/notifications/feed-mark-read`, {
    n,
    limit
  });
  return data;
};
